import { createSelector } from "reselect";

export const getErroOState = (state) => state.roteiroInconsistencia;

export const getRoteiroInconsistencia = createSelector(
  getErroOState,
  (state) => state.erros
);
